// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.



export const devFirebase = {
  apiKey: "AIzaSyAtb-Zoq9n_MwxuoXlWP01A7agU9g2wRsc",
  authDomain: "dpi-gold.firebaseapp.com",
  projectId: "dpi-gold",
  storageBucket: "dpi-gold.appspot.com",
  messagingSenderId: "121907689822",
  appId: "1:121907689822:web:c396f751b82f2f557c37cf",
  measurementId: "G-BMVQFRPH10",
};

export const stageFirebase = {
  apiKey: "AIzaSyD2Q_q7Zo-DT-429CtNYWcqJsMQkC0pkKk",
  authDomain: "dpi-stage.firebaseapp.com",
  projectId: "dpi-stage",
  storageBucket: "dpi-stage.appspot.com",
  messagingSenderId: "91692281243",
  appId: "1:91692281243:web:02966f4162b67acdcf453e"
}

export const prodFirebase = {
  apiKey: "AIzaSyDuqBvOVTy-nAO93a2_AX5o5p1YNtRmzq4",
  authDomain: "dpigold.firebaseapp.com",
  projectId: "dpigold",
  storageBucket: "dpigold.appspot.com",
  messagingSenderId: "659208245886",
  appId: "1:659208245886:web:cf66174c293eb7da8ffe2f",
  measurementId: "G-1T0RM4PPJF",
};

export const environment = {
  production: false,
  PAYPAL_CLIENT_ID: "AetilN9jIn0OEHtKILxmQYJGme6dAFTVsNsngWj3XOoIPU1TfrcNEAYG23bc4qffxuXER0-ByqnzJUKz",

  firebaseMap: [
    {
      self: "localhost",
      firebase: devFirebase,
    },
    {
      self: "app-dev.dpigold.com",
      firebase: devFirebase,
    },
    {
      self: "app-stage.dpigold.com",
      firebase: stageFirebase,
    },
    {
      self: "www.dpigold.com",
      firebase: prodFirebase,
    },
    {
      self: "dpigold.com",
      firebase: prodFirebase,
    },
    {
      self: "app.dpigold.com",
      firebase: prodFirebase,
    },
  ],
  paypalClientIdMaps: [
    {
      self: "localhost",
      id: "AetilN9jIn0OEHtKILxmQYJGme6dAFTVsNsngWj3XOoIPU1TfrcNEAYG23bc4qffxuXER0-ByqnzJUKz",
    },
    {
      self: "app-dev.dpigold.com",
      id: "AetilN9jIn0OEHtKILxmQYJGme6dAFTVsNsngWj3XOoIPU1TfrcNEAYG23bc4qffxuXER0-ByqnzJUKz",
    },
    {
      self: "app-stage.dpigold.com",
      id: "AetilN9jIn0OEHtKILxmQYJGme6dAFTVsNsngWj3XOoIPU1TfrcNEAYG23bc4qffxuXER0-ByqnzJUKz",
    },
    {
      self: "www.dpigold.com",
      id: "Aa7pxjJC6iXTE2FUjdQQFzPiNz9hDru2eG4f6Icw70MO669CA5G4r9ce49XjKebK0cb-BQEWZdaxz3uw",
    },
    {
      self: "dpigold.com",
      id: "Aa7pxjJC6iXTE2FUjdQQFzPiNz9hDru2eG4f6Icw70MO669CA5G4r9ce49XjKebK0cb-BQEWZdaxz3uw",
    },
    {
      self: "app.dpigold.com",
      id: "Aa7pxjJC6iXTE2FUjdQQFzPiNz9hDru2eG4f6Icw70MO669CA5G4r9ce49XjKebK0cb-BQEWZdaxz3uw",
    },
  ],

  urls: [
    {
      self: "localhost",
      user: "https://users-dev.dpigold.com/",
      auth: "https://auth-dev.dpigold.com/",
      wallet: "https://wallet-dev.dpigold.com/",
      price: "https://price-api-dev.dpigold.com/",
      shipment: "https://shipment-dev.dpigold.com/",
      product: "https://products-dev.dpigold.com/",
      stripe: "https://stripe-dev.dpigold.com/",
      notification: "https://notification-dev.dpigold.com/",
      configuration: "https://configuration-dev.dpigold.com/",
    },
    {
      self: "app-dev.dpigold.com",
      user: "https://users-dev.dpigold.com/",
      auth: "https://auth-dev.dpigold.com/",
      wallet: "https://wallet-dev.dpigold.com/",
      price: "https://price-api-dev.dpigold.com/",
      shipment: "https://shipment-dev.dpigold.com/",
      product: "https://products-dev.dpigold.com/",
      stripe: "https://stripe-dev.dpigold.com/",
      notification: "https://notification-dev.dpigold.com/",
      configuration: "https://configuration-dev.dpigold.com/",
    },
    {
      self: "app-stage.dpigold.com",
      user: "https://users-stage.dpigold.com/",
      auth: "https://auth-stage.dpigold.com/",
      wallet: "https://wallet-stage.dpigold.com/",
      price: "https://price-api-stage.dpigold.com/",
      shipment: "https://shipment-stage.dpigold.com/",
      product: "https://products-stage.dpigold.com/",
      stripe: "https://stripe-stage.dpigold.com/",
      notification: "https://notification-stage.dpigold.com/",
      configuration: "https://configuration-stage.dpigold.com/",
    },
    {
      self: "www.dpigold.com",
      user: "https://users.dpigold.com/",
      auth: "https://auth.dpigold.com/",
      wallet: "https://wallet.dpigold.com/",
      price: "https://price-api.dpigold.com/",
      shipment: "https://shipment.dpigold.com/",
      product: "https://products.dpigold.com/",
      stripe: "https://stripe.dpigold.com/",
      notification: "https://notification.dpigold.com/",
      configuration: "https://configuration.dpigold.com/",
    },
    {
      self: "dpigold.com",
      user: "https://users.dpigold.com/",
      auth: "https://auth.dpigold.com/",
      wallet: "https://wallet.dpigold.com/",
      price: "https://price-api.dpigold.com/",
      shipment: "https://shipment.dpigold.com/",
      product: "https://products.dpigold.com/",
      stripe: "https://stripe.dpigold.com/",
      notification: "https://notification.dpigold.com/",
      configuration: "https://configuration.dpigold.com/",
    },
    {
      self: "app.dpigold.com",
      user: "https://users.dpigold.com/",
      auth: "https://auth.dpigold.com/",
      wallet: "https://wallet.dpigold.com/",
      price: "https://price-api.dpigold.com/",
      shipment: "https://shipment.dpigold.com/",
      product: "https://products.dpigold.com/",
      stripe: "https://stripe.dpigold.com/",
      notification: "https://notification.dpigold.com/",
      configuration: "https://configuration.dpigold.com/",
    },
  ],
};


export const getFirebase = () =>
  environment.firebaseMap.find((item) => item.self == location.hostname).firebase;
export const getPayPalClientId = () =>
  environment.paypalClientIdMaps.find((item) => item.self == location.hostname).id;

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
